import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FUNCTION_RESULT_STATUS } from '@nova/common-interfaces';
import { IPayments } from '@rfm/shared-interfaces';
import { BlockUIModule } from 'ng-block-ui';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { CommonComponent } from '../../../../../../lib/components/index.mjs';
import { PaymentService } from '../../../../../shared/services/financial/payment.service.mjs';

@Component({
  selector: 'app-payment-list',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    TabMenuModule,
    BlockUIModule,
    MenuModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectButtonModule,
  ],
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss'],
})
export class PaymentListComponent extends CommonComponent implements OnInit {
  payments: IPayments[] = [];
  filtered_payments: IPayments[] = [];
  activeItem: IPayments | undefined;
  activeTab: any;
  
  tabs: MenuItem[] = [
    { label: "Succeeded", command: () => this.setActiveTab("Succeeded") },
    { label: "Failed", command: () => this.setActiveTab("Failed") }
  ];

  setActiveTab(label: string) {
    this.activeTab = label;

    switch (label.toLowerCase()) {
      case "succeeded":
        this.filtered_payments = this.payments.filter(
          (x) => x.payment_status === "succeeded"
        );
        break;
        case "failed":
          this.filtered_payments = this.payments.filter(
            (x) => x.payment_status !== "succeeded"
          );
          break;
    }
  }

  items: MenuItem[] = [
    {
      label: 'View',
      icon: 'pi pi-file',
      command: () => this.view(this.activeItem!.id),
    },
    {
      label: 'Edit',
      icon: 'pi pi-file-edit',
      command: () => this.edit(this.activeItem!.id),
    },
    {
      label: 'View Customer',
      icon: 'pi pi-file-plus',
      command: () => this.showAll(this.activeItem!.customer_id.id),
    },
  ];

  stateOptions: any[] = [
    { label: 'Succeeded', value: 'succeeded' },
    { label: 'Requires Payment Method', value: 'requires_payment_method' },
  ];

  value: string = 'off';

  buttonChanged(event: any) {
    this.applyFilter();
  }

  applyFilter() {
    if (this.value === 'succeeded') {
      this.filtered_payments = this.payments.filter(
        (x) => x.payment_status === 'succeeded'
      );
    } else if (this.value === 'requires_payment_method') {
      this.filtered_payments = this.payments.filter(
        (x) => x.payment_status === 'requires_payment_method'
      );
    } else {
      this.filtered_payments = this.payments;
    }
  }

  view(payment_id: string) {
    this.router.navigateByUrl('/admin/payments/view/' + payment_id);
  }

  edit(payment_id: string) {
    this.router.navigateByUrl('/admin/payments/edit/' + payment_id);
  }

  showAll(customer_id: string) {
    this.router.navigateByUrl('/admin/customers/view/' + customer_id);
  }

  constructor(
    protected router: Router,
    protected paymentService: PaymentService
  ) {
    super();
    this.isLoading(true);
  }

  selectedPayment: IPayments | undefined;

  rowSelected() {
    console.log('Payment', this.selectedPayment);
    this.router.navigate(['/admin/payments/view/', this.selectedPayment?.id]);
  }

  ngOnInit() {
    this.paymentService
      .getAll()
      .then((result) => {
        if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
          this.payments = result.data!;
          this.applyFilter();
        }
      })
      .finally(() => {
        this.isLoading(false);
      });
  }
}
